export const GOLF_GLOBAL_MODEL_ID = "a1b2c3d4-5e6f-7a8b-9c0d-e1f2a3b4c5d6"

export const GOLF_MODEL_IDS = [
  "d72456f0-9d1c-4f67-8008-9c9b9d42cf7b",
  "4f6b40e7-30d9-4f49-8ab6-5edef72cbdd8",
  "92a86cc4-198a-4bd6-93d1-f3e3122d4fe9",
  "f9224c78-a54d-47ce-98ad-ae6d8e6370c9",
  "946de135-370f-4eca-a6f2-7380dbd4af28",
  "cc34f59b-335a-4a86-87c6-32ff131dddb8",
  "ba02b186-a3e3-48f6-95a2-bbe6138cfe4c",
  "b0512456-1723-494c-9334-89ffdde97297",
  "b4620220-0d7b-4c2d-8614-4013263d6693",
  "2d82bc9a-bd7e-4cd0-aa19-adefb094da72",
  "8d72a434-18cd-4a6f-9af5-08cefd8ebe21",
  "4a23db3d-06c8-408b-aff1-1013bc806f8c",
  "b42e1891-87f3-485b-8813-225f5b609835",
  "b268007d-e254-4b50-8a6d-dceb6f2cd90b",
  "2e563f53-108a-43cc-a560-c63e77f1456c",
]


export const PASSAT_GLOBAL_MODEL_ID = "5546d068-b0b5-4ae3-9978-ff5eb6261c4a"

export const TIGUAN_MODEL_IDS = [
  "f9271d19-0e64-451d-b101-0d905ca8b229",
  "de13756e-16f7-4f8c-97a8-9ed3c3bead3f",
]



export const POLO_MODEL_IDS = [
  "d9277c47-13f3-45af-98b5-07adb687d4a7",
  "db340565-f1b4-4a58-bbb0-fa43574974af",
  "cc42d301-36fb-4029-901f-a7b3676db66b"
]

export const TOURAN_MODEL_IDS = [
  "625b468a-9c2e-4e24-88b5-85a3948afb75"
]


export const BMW_SERIES_3_GLOBAL_MODEL_ID = "ee245f90-f875-4475-82d8-c90401e3c0e8"
export const BMW_SERIES_5_GLOBAL_MODEL_ID = "4a28c6d9-b642-4b13-ac3e-da7a2b0faef1"

export const BMW_X3_MODEL_IDS = [
  "2eefefc1-57b2-4efc-a470-0039f162747f",
  "e53a78ea-15e1-42e5-8915-1628a0fcc371"
]

export const BMW_X5_MODEL_IDS = [
  "3f8174ae-daad-429c-8e86-b43327836d9f"
]
export const BMW_X1_MODEL_IDS = [
  "b6233fe4-0ee8-4f79-b9b0-a70119760b3c",
  "5d13ff22-8f63-4cc8-8022-bd6ee041ba93"
]

export const AUDI_A4_MODEL_IDS = [
  "631dc155-cbeb-4769-8116-094cd7c39c2c",
  "c81b3fa7-8beb-4953-bbd5-ef66e60bbeec",
  "1078dd32-c992-49a5-b113-12940708a81c",
  "c8a90baa-4959-44ca-8233-b1960770f2cf"
]

export const AUDI_A6_MODEL_IDS = [
  "dbe8bef9-5c81-483d-9610-7d861a88185d",
  "c0d5e56d-1f4a-464c-b0d5-005f41aba605",
  "e5d22b9f-0677-4077-bd43-61f0d5389866"
]

export const AUDI_A3_MODEL_IDS = [
  "0a2dc8af-e992-4018-9347-e1775e281830",
  "332e2191-1061-4828-ae14-4a756cd97984",
  "55a42efd-663d-4a65-912b-247951e58820",
  "8261ed29-af75-494e-8087-004554d4cd77",
  "fc398ad0-82fc-4fb6-a06b-6b302b50bcf2"
]

export const AUDI_Q5_MODEL_IDS = [
  "72b616ad-71d1-43cd-be3e-11096e5aa3c7"
]

export const AUDI_Q3_MODEL_IDS = [
  "50753cf2-1e85-445f-8dc3-94d23bab1920"
]

export const MERCEDES_C_CLASS_GLOBAL_MODEL_ID = "65fb8900-7f61-4db8-a03b-adc9816b2c10"

export const MERCEDES_E_CLASS_GLOBAL_MODEL_ID = "a8154aa3-bb06-4905-94e9-5e530ba6dee2"

export const MERCEDES_A_CLASS_MODEL_IDS = [
  "9e8eda5e-d91c-44c3-8780-dca1af28ec4e"
]

export const MERCEDES_GLC_GLOBAL_MODEL_ID = "f0cc7276-09db-43b6-8653-98b5b1e93f53"

export const MERCEDES_CLA_MODEL_IDS = [
  "abbcf1c5-6cb0-4402-bd67-41d58f526993"
]

export const SKODA_OCTAVIA_MODEL_IDS = [
  "6e1ab027-35d0-43aa-977a-cc4d1e06b159",
  "4faba8ee-cae4-4344-b011-8df229d209f5"
]
export const SKODA_FABIA_MODEL_IDS = [
  "47c272e4-4f19-4b09-b15f-846439199d14",
  "8f68b4f0-1814-4604-83d2-2ce0c5bfab79",
  "ed030a76-d9f5-47e8-878f-4ebdfe495ce0"
]

export const SKODA_SUPERB_MODEL_IDS = [
  "f88db0eb-8178-4e53-a198-148673a76362",
  "db082f1e-e7e5-42a8-884e-aa456a819a5a"
]
export const SKODA_KODIAQ_MODEL_IDS = [
  "9cbfd797-0ced-4917-9023-df275469bbd8"
]

export const SKODA_KAMIQ_MODEL_IDS = [
  "ebb21a7c-057d-40bc-a751-4a4658306d65"
]

export const OPEL_ASTRA_MODEL_IDS = [
  "0d26f3d6-abce-412d-ba71-6c421b401c69",
  "e8e0689c-a177-42e9-94be-6ea0d43a2fde",
  "6cb03279-e0f5-4d20-b4ac-aa91578a5c74",
  "725bed2b-1532-4ba3-9363-fccfcf380455",
  "43045728-ae65-4d4e-abf8-fe9c68cf0884",
  "ec0b56d1-9355-40d2-bce4-861d49d6bf36"
]

export const OPEL_CORSA_MODEL_IDS = [
  "d9e64621-9a22-47f1-a53a-30da1fd7ee5c",
  "5eb69dbc-6fa3-4012-8638-57c4e89d4f3c"
]
export const OPEL_INSIGNIA_MODEL_IDS = [
  "bcde052d-0aa5-4330-a2d6-fb45771a15b7",
  "828a9eb6-8802-4ac2-bb4f-289d577343af"
]
export const OPEL_MOKKA_MODEL_IDS = [
  "9661c713-268d-4890-9766-4dbab6f2de89"
]

export const OPEL_ZAFIRA_MODEL_IDS = [
  "4ce0bf92-a7ed-4adb-bd5e-585af36c09d9",
  "29679602-d9fd-4f49-8d5e-74ba2040408e",
  "40ef1888-7ea3-4c43-aae4-378ca98d653c"
]

export const RENAULT_CLIO_MODEL_IDS = [
  "ec150768-2ff5-4022-93e6-a81e3145f409"
]

export const RENAULT_MEGANE_MODEL_IDS = [
  "ae57cbb3-9123-4972-ad83-e6ae48d06c59",
  "1f3dac61-3424-45e5-84ab-584384832869",
  "6529d5a0-6c8e-4a40-a43c-181185a5a18f",
  "2fbaafa1-4e08-4e89-a9f7-eb403faa7054",
  "899ae228-7253-41da-a508-5958030d521b",
  "46be3dfd-a1b5-49e6-82b2-511ff5a4dafe",
  "04e648bc-4617-49f7-9df4-27db2bc66554",
  "39b724f2-f053-4428-bfa8-cdec333b5ae5",
  "c33c7d10-2ae5-4b5c-ae29-0123a7fdfde3",
  "832284e5-43fb-4bd1-b018-d75dd8da9ce1",
  "51b705dd-84ae-434c-a572-4ab143fc87c1"
]
export const RENAULT_CAPTUR_MODEL_IDS = [
  "a5cd5fea-392e-49d1-a686-6d1e4059f9a1"
]

export const RENAULT_SCENIC_MODEL_IDS = [
  "d2226767-fcc2-4499-bfb1-d13da462f2cc",
  "832284e5-43fb-4bd1-b018-d75dd8da9ce1",
  "4735081f-848a-4a6d-8fa2-1cde1843705f"
]
export const RENAULT_KADJAR_MODEL_IDS = [
  "af6033d5-8751-4d3d-a166-cdc480bb6d39"
]

export const FORD_FOCUS_MODEL_IDS = [
  "94c03685-e24c-4d4a-9f04-804790e69daf",
  "60a699f6-2808-40cb-b52f-577c00592c2f",
  "76b08228-4f1c-4431-bf32-3d8e0b1908e0",
  "86a886a9-3d72-496f-8c80-0a52ff4aa0eb"
]

export const FORD_FIESTA_MODEL_IDS = [
  "075fd071-c671-4cdb-b3f7-9df77c3bb8bd",
  "0eab7002-6761-426f-9896-015d8806307b"
]
export const FORD_KUGA_MODEL_IDS = [
  "ed1ea3f3-0552-473e-adf3-6d154b2f67b7"
]

export const FORD_MONDEO_MODEL_IDS = [
  "d4d3bd50-d1b6-43f3-b1d8-50ad67140c2c",
  "8bac7a12-7ee6-4d38-bdc7-8cb9fafddafd"
]
export const FORD_PUMA_MODEL_IDS = [
  "d37c2750-57d1-48aa-bddd-1f89330d8d0f"
]


export const PEUGEOT_308_MODEL_IDS = [
  "3c311dc2-7b75-4506-99c4-3cd3dff0eeb7",
  "8fca679a-63eb-4099-8748-42eb2634e117",
  "e4f5e694-3794-4f59-ad97-42aa59eb5fbc"
]

export const PEUGEOT_208_MODEL_IDS = [
  "221d7fd7-8690-489b-941d-874a5f6e7d7a"
]

export const PEUGEOT_3008_MODEL_IDS = [
  "5fa6d34b-e318-4c13-a369-af34853611ed"
]
export const PEUGEOT_508_MODEL_IDS = [
  "767648fe-91d8-41f9-bb91-96e4569fca62"
]

export const PEUGEOT_2008_MODEL_IDS = [
  "f0ce424c-0973-45d8-a1ac-666dfcdcff6f"
]

export const TOYOTA_COROLLA_MODEL_IDS = [
  "44dd695b-42e1-4c2b-9cde-6568b8826680",
  "4a061dcb-884c-4727-99ad-1e3053042abc",
  "faf628aa-21c4-4b32-8a43-819a758d4177",
  "b65e2281-0124-4683-8c0f-44a2d0b61de7",
  "d7304a3c-1a1e-4077-bdeb-cc7b77322510"
]

export const TOYOTA_YARIS_MODEL_IDS = [
  "331434ad-381b-468f-bdb0-fd9d85c35330",
  "e68a51e4-3d3e-46f5-ac72-b91557249262",
  "73aea47a-6980-4b3d-9f4f-1d904956078f"
]

export const TOYOTA_RAV_4_MODEL_IDS = [
  "36210244-d9a4-44fc-a0aa-f7a40271866c"
]

export const TOYOTA_AURIS_MODEL_IDS = [
  "ee723488-06a5-4489-82b2-1fa522745f58",
  "d3dd78e1-a977-452f-b679-ac7843357342"
]

export const TOYOTA_CHR_MODEL_IDS = [
  "8831d3a9-0101-41e6-b2bb-bf1ca43b3cbe"
]






// WEBPACK FOOTER //
// ./src/carModelIds.ts